import React, { useState } from "react";
import { DropzoneArea } from "material-ui-dropzone";
import axios, { mensajeError } from "../../../utils/axios";

// En el celular no se arrastra: se toca para elegir el archivo
const TACTIL = typeof window !== "undefined" && window.matchMedia && window.matchMedia("(hover: none)").matches;
// El componente trae 3 MB por defecto y rechazaba en silencio los PDF escaneados con el celular
const MAX_MB = 20;

export default function ProcedureUploadForm({ transaction, reload }) {
  const [files, setFiles] = useState([]);
  const handleChange = (filesUploaded) => {
    setFiles(filesUploaded);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!files[0]) {
      alert("Por favor seleccione un documento a firmar");
    } else {
      const data = new FormData();
      data.append("file", files[0], files[0].name);
      axios
        .post(`api/documento/upload/${transaction}`, data)
        .then((res) => {
          reload();
        })
        .catch((err) => {
          alert(mensajeError(err, "Hubo un error al subir el archivo"));
        });
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <DropzoneArea
        onChange={handleChange}
        acceptedFiles={["application/pdf"]}
        filesLimit={1}
        maxFileSize={MAX_MB * 1024 * 1024}
        showFileNames
        previewText="Archivo elegido:"
        dropzoneText={TACTIL ? "Toca aquí para elegir tu PDF" : "Arrastra tu PDF aquí o haz clic para elegirlo"}
        getDropRejectMessage={(file) =>
          file.type !== "application/pdf"
            ? `${file.name} no es un PDF. Sube el documento en formato PDF.`
            : `${file.name} pesa más de ${MAX_MB} MB. Intenta con un archivo más liviano.`
        }
        getFileAddedMessage={(fileName) => `El archivo ${fileName} ha sido añadido`}
        getFileRemovedMessage={(fileName) => `El archivo ${fileName} ha sido eliminado de la selección`}
      />
      <div style={{ justifyContent: "center", display: "flex" }}>
        <button style={{ left: 0 }} class="ContinueForm" type="submit">
          Subir Archivo
        </button>
      </div>
    </form>
  );
}
